import { BANK_ACCOUNT_INFO_API } from 'constants/AppConstants';

export default async (bankAccountDetails) => {
  try {
    const response = await fetch(BANK_ACCOUNT_INFO_API, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(bankAccountDetails),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
